import { View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { Image, StyleSheet } from 'react-native'
import { theme } from '../../theme'

const IMAGE_SIZE = 48

interface ImageRoundedProps {
  image: string | null
  size?: number
}
export const ImageRounded: FunctionComponent<ImageRoundedProps> = ({ image, size = IMAGE_SIZE }) => {
  const style = [styles.image, { width: size, height: size, borderRadius: size / 2 }]

  if (!image) {
    return <View style={style} />
  }
  return <Image source={{ uri: image }} style={style} resizeMode="contain" />
}

const styles = StyleSheet.create({
  image: {
    borderColor: theme.colors.silver,
    borderWidth: 0.5,
  },
})
